var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightsRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.5563V16.8562L14.4737 10.1063V2.68125C14.4737 1.56075 13.5921 0.65625 12.5 0.65625C11.4079 0.65625 10.5263 1.56075 10.5263 2.68125V10.1063L0 16.8562V19.5563L10.5263 16.1812V23.6062L7.89474 25.6312V27.6562L12.5 26.3063L17.1053 27.6562V25.6312L14.4737 23.6062V16.1812L25 19.5563Z",
    fill: "#AB0101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightsRed);
export default __webpack_public_path__ + "static/media/flights-red.eb3bca3e76f7301dfa6a53a90252c657.svg";
export { ForwardRef as ReactComponent };